// extracted by mini-css-extract-plugin
export default {"formError":"auth__formError__IMzquE","fadeIn":"auth__fadeIn__IHBieR"};